module.exports = __webpack_public_path__ + "img/member4.beb05416.png";